import { Snippet } from "@heroui/react";
import React, { FC } from "react";

type IdViewProps = {
  children:any;
  textToCopy:any;
  className?:any;
}

const IdView:FC<IdViewProps> = ({children, textToCopy, className}) => {
  const color = '#006FEE'
  const bg = '#E0EDFC'
  return(
    <Snippet
      symbol={null}
      codeString={textToCopy}
      tooltipProps={{
        color: "foreground",
        // disableAnimation: true,
        placement: "right",
        closeDelay: 0,
      }}
      // hideCopyButton
      className={`text-[14px] leading-[20px] !font-medium whitespace-nowrap inline-flex items-center ${className}`}
      classNames={{
        base: `bg-[${bg}] rounded-[20px] px-[8px] h-[24px] gap-[4px] py-[2px] text-[14px] leading-[20px] !font-medium whitespace-nowrap inline-flex items-center`,
        pre: `bg-transparent text-[${color}] !text-[14px] !leading-[20px] !font-medium whitespace-nowrap`,
        copyButton: `text-[${color}] !min-w-[22px] !max-w-[16px] h-[16px] hover:text-[${color}]`,
        checkIcon: `text-[${color}] h-[12px]`,
        content:'text-[14px] leading-[20px] !font-medium whitespace-nowrap'
      }}
    >
      {children}
    </Snippet>
  )
}

export default IdView
